import {ERROR_CODES} from '../../utils';

export const BASE_API_URL = import.meta.env.VITE_APP_BASE_URL;
export const FAILURE_RESPONSE_STATUSES = [400, 401];
export const CORS_ERRORS = ['Failed to fetch', 'Load Failed', 'NetworkError'];
export const ERR_INTERNET_DISCONNECTED_MESSAGE = 'ERR_INTERNET_DISCONNECTED';
export const RETRY_RESPONSE_STATUSES = [500, 502, 503, 504, 400];
export const RETRY_ERROR_CODES = [ERROR_CODES.decryptionError];
export const MAX_RETRIES_NUMBER = 0;
